import SimpleQuestion from "./SimpleQuestion";
import * as theme from "../theme";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { useEffect, useState } from "react";
import { isAnswerEmpty } from "../store/helperfuncs";

const Year = ({ text, node, handleAnswerChange, isNodeOpen, qfusermode }) => {
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      rightComponent={
        <YearInput
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></YearInput>
      }
    ></SimpleQuestion>
  );
};

export const YearInput = ({
  node,
  handleAnswerChange,
  miniFormMode,
  handleAnswerChangeForMiniForm,
  code,
  questionid,
  qfusermode,
}) => {
  const [input, setInput] = useState(
    isAnswerEmpty(node.answer) ? null : node.answer
  );

  const handleChange = (event) => {
    let input_ = event.target.value;
    if (input_.length <= 4 && !isNaN(input_))
      setInput(input_)

  };
  const handleBlur = (event) => {
    let input_ = event.target.value;
    if (input_.length <= 4 && !isNaN(input_)) handleAnswerChange(event.target.value);
  }

  const handleChangeFormMiniForm = (event) => {
    let input = event.target.value;

    if (input.length <= 4)
      handleAnswerChangeForMiniForm(code, questionid, event.target.value);
  };

  const decideTheValue = (code, node, questionid) => {
    if (!node) return "";
    if (!node.answer) return "";
    if (!node.answer.internal) return "";
    if (!node.answer.internal[code]) return "";
    if (!node.answer.internal[code][questionid]) return "";

    return node.answer.internal[code][questionid];
  };

  return (
    <input
      type="text"  
      inputmode="numeric" 
      style={{ ...theme.inputStyle, width: "6vw", textAlign: "center" }}
      min={node.logic.min ? node.logic.min : 1000}
      max={node.logic.max ? node.logic.max : 9999}
      value={
        miniFormMode
          ? decideTheValue(code, node, questionid)
          : input
          ? input
          : ""
      }
      onBlur={miniFormMode ? handleChangeFormMiniForm : handleBlur}
      onChange={handleChange}
      readOnly={qfusermode === INSURER ? true : false}
    ></input>
  );
};

export default Year;
